import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareEmail({ url, handleAnalytics, linkTitle }) {
  return (
    <Link
      href={url}
      onClick={() => handleAnalytics('email-share')}
      style={{ color: grey600 }}
      title={linkTitle}
      data-testid="social-share-email"
    >
      <Icon name="share-email" size="lg" />
    </Link>
  );
}

SocialShareEmail.propTypes = {
  url: PropTypes.string,
  handleAnalytics: PropTypes.func,
  linkTitle: PropTypes.string,
};

export default SocialShareEmail;
